import React, { useState } from 'react';

import ContentViewComponent from '#app/Component/ContentViewComponent';
import List from '#app/View/Billing/RefundList/components/List';
import Search, { Filters } from '#app/View/Billing/RefundList/components/Search';

const RefundList: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [filters, setFilters] = useState<Filters>({
    types: [],
    channels: [],
    orderClientStates: [],
    number: null,
    email: null,
    name: null,
  });

  return (
    <ContentViewComponent breadcrumbs={{ title: 'Liste des remboursement client', context: 'Facturation' }}>
      <Search handleSearch={(data) => setFilters(data)} loading={loading} />
      <List filters={filters} loading={loading} setLoading={(loading) => setLoading(loading)} context="refund" />
    </ContentViewComponent>
  );
};

export default RefundList;
